module.exports = __webpack_public_path__ + "img/control_de_calidad_3-4.531ab015.webp";